import { Injectable } from '@angular/core';
import { HttpService } from '../../../services/http.service';

@Injectable({
  providedIn: 'root'
})
export class SupportService {
  constructor(private httpService: HttpService) { }
  requestACall(payload: any) {
    return this.httpService.post('api/RequestACall', payload);
  }  
  changePassword(payload: any) {
    return this.httpService.post('api/User/changepassword', payload);
  } 
  contactSupport(payload: any) {
    return this.httpService.post('api/ContactSupport', payload);
  }
  helpSupport(payload: any) {
    return this.httpService.get('api/HelpSupport', payload);
  }
}
